module.exports = __webpack_public_path__ + "static/media/OH.58689820.jpg";